import { render } from "./FreeWidgetsStrip.vue?vue&type=template&id=fafdf036"
import script from "./FreeWidgetsStrip.vue?vue&type=script&lang=js"
export * from "./FreeWidgetsStrip.vue?vue&type=script&lang=js"

import "./FreeWidgetsStrip.vue?vue&type=style&index=0&id=fafdf036&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FreeWidgetsStrip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fafdf036"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fafdf036', __exports__)) {
    api.reload('fafdf036', __exports__)
  }
  
  module.hot.accept("./FreeWidgetsStrip.vue?vue&type=template&id=fafdf036", () => {
    api.rerender('fafdf036', render)
  })

}


export default __exports__